import InnerComponent from '@Components/Sales/Consumption/ViewConsumption';
import orgContainer from '@Components/AppContainer';

const ViewConsumption = () => ((orgContainer(InnerComponent)));
export default ViewConsumption;